/**
 * Checkout Selectors
 */

import { createSelector } from 'reselect';

export const getCheckout = ({ checkout }: GQL.IViewer) => checkout;

export const hasValidCheckout = createSelector<GQL.IViewer, GQL.IOrder | null, boolean>(
  getCheckout,
  (checkout) => {
    return !!checkout && !!checkout.license_line_items && checkout.license_line_items.length > 0;
  },
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/selectors/checkout.ts